const CNPJ_ALPHANUMERIC_MASK = [
	/[A-Za-z0-9]/,
	/[A-Za-z0-9]/,
	".",
	/[A-Za-z0-9]/,
	/[A-Za-z0-9]/,
	/[A-Za-z0-9]/,
	".",
	/[A-Za-z0-9]/,
	/[A-Za-z0-9]/,
	/[A-Za-z0-9]/,
	"/",
	/[A-Za-z0-9]/,
	/[A-Za-z0-9]/,
	/[A-Za-z0-9]/,
	/[A-Za-z0-9]/,
	"-",
	/\d/,
	/\d/,
];

const cnpjUppercasePipe = (conformedValue) => conformedValue.toUpperCase();

export { CNPJ_ALPHANUMERIC_MASK, cnpjUppercasePipe };
